module.exports = __webpack_public_path__ + "static/media/Notification.6b7e8b02.wav";